
export default {
  languageName: {
    fi: () => "suomeksi",
    sv: () => "på svenska",
    en: () => "in English"
  },
  mainContentLinkText: () => "Go directly to content",
  verification: {
    cancelButtonText: () => "Cancel"
  },
  cancelConfirmation: {
    title: () => "Do you want to quit?",
    body: () => "If you quit logging in, you can’t continue to use this service.",
    yes: () => "Quit",
    no: () => "Cancel"
  },
  authenticationCancelError: {
    title: () => "Identification cancelled",
    body: () => "Information you gave was not forwarded."
  },
  loggedOut: {
    title: () => "You have been logged out of the service",
    body: () => "If you want, you can log into the service again.",
    close: () => "Close"
  },
  footer: {
    dataprotectionLinkText: () => "Data protection at OP",
    accessibilityLinkText: () => "Accessibility statement",
    accessibilityLinkTarget: () => "https://www.op.fi/accessibility/identification-accessibility-statement",
    termsLinkText: () => "Terms and conditions",
    copyrightText: () => "© OP Pohjola"
  },
  applicationError: {
    title: () => "We are sorry, there is a disruption in our service",
    body: () => "Service is temporarily unavailable. Please try again later."
  },
  forbiddenError: {
    title: () => "Identification failed",
    body: () => "You cannot log in using the credentials you entered. Please contact your OP cooperative bank or OP’s customer service."
  },
  passwordChangeRequired: {
    title: () => "Authentication failed",
    body: () => "You must change your password. Change the password at op.fi."
  },
  selectRepresentationError: {
    title: () => "We are sorry, there is a disruption in our service",
    body: () => "Customer role selection is temporarily unavailable. Please try again later."
  },
  fethRepresentationsError: {
    title: () => "Customer roles couldn’t be retrieved",
    body: () => "Please try again soon. If necessary, please contact your OP cooperative bank or OP Customer Service."
  },
  authSectionDivider: () => "OR",
  trustnetwork: {
    title: () => "Other means of user authentication",
    privacyText: () => "In connection with authentication, your personal ID and name are forwarded to OP.",
    privacyLinkText: () => "Privacy Notice",
    privacyLinkTarget: () => "https://isb.op.fi/privacy-info?lang=en"
  },
  idkaart: {
    title: () => "Log in with the Estonian ID card"
  },
  representation: {
    title: () => "Select customer role",
    titleChange: () => "Change customer role",
    privateCustomer: () => "Private customer",
    companyCustomer: () => "Corporate customer",
    companyId: () => "Business ID",
    doubleAgreement: {
      YOP: () => "(OP corporate eServices agreement)",
      KOPA: () => "(Corporate eService agreement)",
      YRVEIKKO: () => "(Corporate insurance agreement)",
      YDAS: () => "(Agreement for digital transactions)"
    },
    search: {
      title: () => "Search for company",
      placeholder: () => "Enter company name or business ID",
      noResults: () => "No search results",
      ariaLabel: () => "Writing will filter company list automatically"
    },
    back: () => "Back",
    current: () => "your current customer role"
  },
  accessibility: {
    loading: () => "Loading",
    businessId: () => "Business ID",
    welcomeMessage: {
      op: () => "Log in with an OP user ID.",
      other: () => "Log in with an OP user ID or select another identification method."
    },
    representationlist: {
      onePersonOneCompany: () => "Select your customer role: personal customer or corporate customer.",
      noPersonManyCompanies: () => "Select your customer role. You have corporate roles [COUNT].",
      onePersonManyCompanies: () => "Select your customer role: personal customer or corporate customer. You have corporate roles [COUNT]."
    },
    languageNotification: () => "Page language changed to English"
  }
}